import axiosInstance from '../config/axios';
import { API_ENDPOINTS } from '../config/api';

export async function getPinnedStudies() {
  const res = await axiosInstance.get(API_ENDPOINTS.pinnedStudies.list);
  return res.data.pinnedStudies || [];
}

export async function pinStudy(projectId) {
  const res = await axiosInstance.post(API_ENDPOINTS.pinnedStudies.pin(projectId));
  return res.data.pinnedStudies || [];
}

export async function unpinStudy(projectId) {
  const res = await axiosInstance.delete(API_ENDPOINTS.pinnedStudies.unpin(projectId));
  return res.data.pinnedStudies || [];
}
